var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.32 28.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.08,11.49l2.79-2.92L17.35,3a2.15,2.15,0,0,0-3,0L8.78,8.73l1.69,1.92h6A6.31,6.31,0,0,1,20.08,11.49Z",
    transform: "translate(-1.68 -2.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.26,12.92l2.56,2.6L18,13.28a3.34,3.34,0,0,0-1.52-.36Z",
    transform: "translate(-1.68 -2.35)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.84,9.45,2.32,15a2.11,2.11,0,0,0,0,3l5.52,5.52,7-7Zm0,8.89a1.88,1.88,0,1,1,1.89-1.88A1.88,1.88,0,0,1,7.8,18.34Z",
    transform: "translate(-1.68 -2.35)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,23,8.87,24.58,14.33,30a2.14,2.14,0,0,0,3,0l5.46-5.45-2.76-2.76A6.44,6.44,0,0,1,16.47,23l-6,0Z",
    transform: "translate(-1.68 -2.35)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,19.67l-2.15-2.14L13.39,20h3.12A2.73,2.73,0,0,0,18,19.67Z",
    transform: "translate(-1.68 -2.35)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.4,15,23.84,9.41l-2.76,2.73a6.26,6.26,0,0,1,1.69,4.38h0a6.42,6.42,0,0,1-1.65,4.36l2.69,2.66L29.4,18A2.18,2.18,0,0,0,29.4,15Z",
    transform: "translate(-1.68 -2.35)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.85,16.46a3.55,3.55,0,0,0-.78-2.31l-2.3,2.37L19,18.83a3.44,3.44,0,0,0,.84-2.37Z",
    transform: "translate(-1.68 -2.35)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21e8eec45313c8e82da4b9dcce771bea.svg";
export { ForwardRef as ReactComponent };